import React from 'react';
import css from './SectionStocks.css';
import {
    IconCherryXL,
    IconCherryXXL,
    IconGiftcardXL,
    IconGiftcardXXL,
    IconPiggyBankSaveXL,
    IconPiggyBankSaveXXL,
} from '../../../../icons';

export default ({ isMobile }) => (
    <>
        <h2 className={css.heading}>Das kannst Du gewinnen</h2>
        <div className={css.grid}>
            <div className={css.gridItem}>
                {isMobile ? <IconCherryXL /> : <IconCherryXXL />}
                <h3>Ausgelesene Produkte</h3>
                <p>
                    Gewinne hochwertige Produkte unserer Partner - von Pflegeartikeln bis zu
                    praktischem Equipment fürs Reiten.
                </p>
            </div>
            <div className={css.gridItem}>
                {isMobile ? <IconGiftcardXL /> : <IconGiftcardXXL />}
                <h3>Virtuelle Gutscheine</h3>
                <p>
                    Erhalte Gutscheine deiner Lieblingsmarken und löse sie direkt im Onlineshop oder
                    Reitsportgeschäft ein.
                </p>
            </div>
            <div className={css.gridItem}>
                {isMobile ? <IconPiggyBankSaveXL /> : <IconPiggyBankSaveXXL />}
                <h3>Kostenlose Credits</h3>
                <p>
                    Sichere dir kostenlose Credits, um alle Funktionen zu nutzen - ganz ohne zu
                    bezahlen.
                </p>
            </div>
        </div>
    </>
);
